import Newsletter_36Container from "./container/Newsletter_36Container";
export default Newsletter_36Container;
